"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.amountFormatter = exports.parseNumberToBigInt = exports.makeShortId = void 0;
const big_js_1 = __importDefault(require("big.js"));
// Big constructor will throw if argument is not a string or Big
big_js_1.default.strict = true;
const DEFAULT_MAX_DIGITS = 9;
const makeShortId = (idString) => {
    return typeof idString === "string"
        ? `${idString.slice(0, 4)}...${idString.slice(-4)}`
        : "";
};
exports.makeShortId = makeShortId;
const parseNumberToBigInt = (v, maxDigits = DEFAULT_MAX_DIGITS) => {
    const amount = (0, big_js_1.default)(v);
    const precision = (0, big_js_1.default)(`1e${maxDigits}`);
    const b = amount.times(precision).toFixed();
    return BigInt(b);
};
exports.parseNumberToBigInt = parseNumberToBigInt;
const amountFormatter = (amt, minDigits = 0, maxDigits = DEFAULT_MAX_DIGITS) => {
    const precision = (0, big_js_1.default)(`1e${-maxDigits}`);
    const amount = (0, big_js_1.default)(amt.toString()).times(precision);
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: minDigits,
        maximumFractionDigits: maxDigits,
    }).format(amount.toFixed()); // Typescript complains about the string parameter but it should be supported
};
exports.amountFormatter = amountFormatter;
